import {Airgram} from "@airgram/web";
import store from './store';

const APP_ID = 933908;
const APP_HASH = 'c7a6863befcd8d3970ecc91d814e1f9a';

const airgram = new Airgram({
    context: {
        $store: store,
    },
    apiId: APP_ID,
    apiHash: APP_HASH,
    logVerbosityLevel: 2,
    jsLogVerbosityLevel: 'error',
    // useTestDc: true,
});
//
// airgram.api.getCountryCode()
// .then(result => {
//     console.log(result);
// });

export default airgram;
